import { useState } from "react";
import { ReactComponent as EditIcon } from "../../../assets/img/EditTask.svg";
import OffCanvas from "../../../components/offCanvas";
import { AddConditions } from "./AddConditions";
import {
  FilterCriteria,
  GetPatientConditions,
  GridDataRequest,
  GridDataResponse,
} from "patients-experience-client";
import Toaster, { ToastConfig } from "../../../components/Toaster";
import { ErrorTypes } from "../../../interfaces/errors";
import { createPatientApi } from "../../../api-helpers/PatientApiHelper";
import { ConditionHeader } from "./ConditionHeader";
import { ColDef } from "ag-grid-community";
import { GenericGrid } from "../../../grid/GenericGrid";
import { formatDate } from "../../../helper/dateFormatter";
import { createGridApi } from "../../../api-helpers/GridApiHelper";

interface ConditionProps {
  patientId: string;
}
export const Condition = (props: ConditionProps) => {
  const patientApi = createPatientApi();
  const gridApi = createGridApi();

  const [selectedCondition, setSelectedCondition] = useState(
    {} as GetPatientConditions,
  );
  const [showToast, setShowToast] = useState(false);
  const [offCanvasTitle, setOffCanvasTitle] = useState("");
  const [offCanvasShow, setOffCanvasShow] = useState(false);
  const [offCanvasComp, setOffCanvasComp] = useState("");
  const [gridReloadKey, setGridReloadKey] = useState(0);
  const [filters, setFilters] = useState<FilterCriteria[]>([]);

  const [toastConfig, setToastConfig] = useState<ToastConfig>({
    type: "success" as ErrorTypes,
    title: "",
    icon: "",
  });

  const reloadGrid = () => {
    setGridReloadKey(gridReloadKey + 1);
  };

  const EditButton = (props: any) => {
    const handleClick = (condition: GetPatientConditions) => {
      setSelectedCondition(condition);
      handleOffCanvasShow("editConditions");
    };

    return (
      <div
        className="d-flex align-items-center justify-content-center w-100 h-100"
        role="button"
        onClick={() => handleClick(props.data)}
      >
        <EditIcon />
      </div>
    );
  };

  const colDefs: ColDef[] = [
    {
      field: "conditionName",
      headerName: "Condition",
      pinned: "left",
      minWidth: 400,
      sortable: true,
    },
    {
      field: "details",
      headerName: "Details",
      minWidth: 400,
      sortable: true,
      valueGetter: (params) => {
        const details = params.data?.details;
        return details && details.trim() !== "" ? details : "-";
      },
    },
    {
      field: "statusName",
      headerName: "Status",
      minWidth: 80,
      sortable: true,
      cellRenderer: (params: any) => {
        const status = params.value;
        if (status === "Active") {
          return <span className="badge background-completed">{status}</span>;
        }
        if (status === "Inactive") {
          return <span className="badge background-cancelled">{status}</span>;
        }
        return <span className="">{"-"}</span>;
      },
    },
    {
      field: "conditionRecStatusName",
      headerName: "Condition Rec Status",
      minWidth: 40,
      sortable: true,
      cellRenderer: (params: any) => {
        const status = params.value;
        if (status === "Reviewed") {
          return <span className="badge background-completed">{status}</span>;
        }
        if (status === "Not Reviewed") {
          return <span className="badge background-cancelled">{status}</span>;
        }
        return <span className="">{"-"}</span>;
      },
    },

    {
      field: "updatedAt",
      headerName: "Last Updated",
      minWidth: 130,
      sortable: true,
      valueFormatter: function (params: any) {
        return formatDate(params.data.updatedAt);
      },
    },
    {
      field: "addedBy",
      headerName: "Added By",
      minWidth: 200,
      sortable: true,
    },
    {
      cellRenderer: EditButton,
      maxWidth: 50,
      pinned: "right",
      sortable: false,
    },
  ];

  const loadData = async (
    request: GridDataRequest,
  ): Promise<GridDataResponse> => {
    return (await gridApi.gridControllerGetConditionGridData(request)).data;
  };

  const handleOffCanvasShow = (comp: string) => {
    if (comp === "addConditions") {
      setOffCanvasTitle("Add Condition");
    }
    if (comp === "editConditions") {
      setOffCanvasTitle("Edit Condition");
    }

    setOffCanvasComp(comp);
    setOffCanvasShow(!offCanvasShow);
  };

  const handleAddUpdateConditionForm = async (toasterConfig: ToastConfig) => {
    setToastConfig(toasterConfig);
    setShowToast(true);
  };
  return (
    <>
      <div className="row">
        <Toaster
          show={showToast}
          onClose={() => setShowToast(false)}
          type={toastConfig.type}
          title={toastConfig.title}
          message={toastConfig.message}
          icon={toastConfig.icon}
        />
      </div>
      <ConditionHeader
        patientId={props.patientId}
        offCanvasShowCallback={handleOffCanvasShow}
        onUpdateFilters={setFilters}
      />
      <div className="medication-table">
        <GenericGrid
          gridId="conditions-grid"
          colDefs={colDefs}
          dataProvider={loadData}
          filters={filters}
          fixedHeight="350px"
          key={gridReloadKey}
          pagination={false}
        />
      </div>
      <OffCanvas
        title={offCanvasTitle}
        offCanvasShow={offCanvasShow}
        setOffCanvasShow={setOffCanvasShow}
        offCanvasComp={offCanvasComp}
      >
        {offCanvasComp === "addConditions" && (
          <AddConditions
            patientId={props.patientId}
            onSubmitCondition={handleAddUpdateConditionForm}
            setOffCanvasShow={setOffCanvasShow}
            reloadGrid={reloadGrid}
          />
        )}

        {offCanvasComp === "editConditions" && (
          <AddConditions
            patientId={props.patientId}
            onSubmitCondition={handleAddUpdateConditionForm}
            setOffCanvasShow={setOffCanvasShow}
            reloadGrid={reloadGrid}
            selectedCondition={selectedCondition}
          />
        )}
      </OffCanvas>
    </>
  );
};
